import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Page } from '../../models/page-wrapper.model';
import { Resource } from './resource.model';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {

  private apiUrl = `${environment.restApiUrl}resources`;

  constructor(private http: HttpClient) { }

  /**
   * Fetches a paginated and filtered list of resources from the backend.
   * The `HttpParams` object can be used to pass along QueryDSL predicates
   * and Spring Pageable parameters (e.g., page, size, sort).
   *
   * @param params The query parameters for filtering and pagination.
   * @returns An Observable of a Page of Resource objects.
   */
  getAllResources(params: HttpParams): Observable<Page<Resource>> {
    return this.http.get<Page<Resource>>(this.apiUrl, { params });
  }

  // Since resources are typically pre-defined, create, update, and delete
  // methods are not included, matching the backend controller's design.
}

